var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layoutError',{on:{"onSubmit":_vm.onSubmit},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Lo sentimos, tu sesión caducó. ")]},proxy:true},{key:"body",fn:function(){return [_vm._v(" Por favor, inicie sesión nuevamente. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }